var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right_bottom"},[_c('dv-capsule-chart',{staticStyle:{"width":"100%","height":"260px"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }